




import { computed, defineComponent, ref } from '@vue/composition-api'

export default defineComponent({
  name: 'VLeftRight',

  setup() {}
})
